import styles from './docs.module.scss';
import { useState } from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'next-i18next';

const Group = ({ data }) => {
  const [opened, setOpened] = useState(false);

  return (
    <div className={styles.group}>
      <div className={styles.groupHeader}>
        <span>{data.title}</span>
        <span className={styles.btn} onClick={() => setOpened(!opened)}>
          +
        </span>
      </div>
      <ul className={clsx(styles.groupFiles, { [styles.groupFilesOpened]: opened })}>
        {data.documents &&
          data.documents.map(f => (
            <li key={f.id}>
              <a target="_blank" href={f.file}>
                {f.title}
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
};

const variants = {
  initial: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 1.3,
      delay: 0.5,
    },
  },
  hidden: { opacity: 0 },
};

const Docs = ({ data = [] }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '-100px 0px',
  });
  const { t } = useTranslation(['common', 'about']);

  return (
    <motion.div ref={ref} className={styles.wrapper}>
      <motion.h2
        className={styles.header}
        exit={{
          opacity: 0,
          y: '-15%',
          transition: { duration: 0.3 },
        }}
        initial={{
          overflow: 'hidden',
          width: '0%',
          whiteSpace: 'nowrap',
        }}
        animate={
          inView
            ? {
                width: '100%',
                transition: { duration: 2, delay: 0.3 },
              }
            : 'false'
        }
      >
        {t('Основные документы компании')}
      </motion.h2>
      <motion.div
        className={styles.files}
        initial="initial"
        animate={inView ? 'visible' : 'false'}
        exit="hidden"
        variants={variants}
      >
        {data.map(group => (
          <Group key={group.id} data={group} />
        ))}
      </motion.div>
    </motion.div>
  );
};

export default Docs;
